import mixpanel from 'mixpanel-browser'
import config from '@/config'

const mixpanelAvailable = config.mixpanel && config.mixpanel.projectToken

function getCookie(cname) {
  const name = `${cname}=`
  const decodedCookie = decodeURIComponent(document.cookie)
  const ca = decodedCookie.split(';')
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i]
    while (c.charAt(0) === ' ') {
      c = c.substring(1)
    }
    if (c.indexOf(name) === 0) {
      return c.substring(name.length, c.length)
    }
  }
  return ''
}

const init = () => {
  if (mixpanelAvailable) {
    mixpanel.init(config.mixpanel.projectToken, {
      api_host: config.mixpanel.proxyUrl,
    })

    const userId = getCookie('aha-user-id')
    if (userId) {
      mixpanel.identify(userId)
    }
  }
}

const track = (eventName, eventProps) => {
  const userId = getCookie('aha-user-id')
  if (mixpanelAvailable && userId) {
    mixpanel.track(eventName, eventProps)
  }
}

export default {
  init,
  track,

}
